<div class="searchbar border-grey-1 bg-color-white" id="barra-pesquisa" aria-label="pesquisarEmCursos" role="searchbox">
  <form [formGroup]="formularioPesquisaInstituicao" (ngSubmit)="onPesquisar()">
    <div class="input-container" role="none">
      <input type="search" class="input color-dark bg-color-white" id="busca-{{ componenteAtual }}"
        placeholder="Institição de busca" name="StringBusca" [value]="searchString" formControlName="stringBusca"
        aria-label="digiteoTextoDaSuaPesquisa" />
      <button type="submit" value="buscar no catálogo" class="search-button">
        buscar no catálogo
      </button>
      <span role="separator" class="vert-line"></span>
      <button type="button" class="filters-btn cursor-pointer" (click)="toggle = !toggle" *ngIf="instituicoes">
        filtros <span role="img" class="filter-toggle"></span>
      </button>
    </div>

    <hr class="bg-color-dark-grey hr-line" *ngIf="toggle && instituicoes" />

    <div class="filters" [ngClass]="{ open: toggle && instituicoes }">
      <div role="none">

        <div class="odernar-div">
          <p class="filter-title">Ordenar por</p>
          <p class="filter-group" *ngFor="let ordenacao of ordenarPor">
            <label class="filter-label"><input type="radio" name="ordenacao" id="{{ ordenacao.nome | normalize }}"
                class="filter-input" formControlName="ordenacao" [value]="ordenacao.id" />{{ ordenacao.nome }}</label>
          </p>
        </div>

        <div class="filtro-div">
          <p class="filter-title">Filtrar por</p>
          <p>UF:</p>
          <div class="uf-div">
            <ul>
              <input (change)="setAll()" type="checkbox" />
              Todos
              <li *ngFor="let uf of estados" style="padding: 2px !important;" id="ufs">
                <input (change)="getSelectedEstado(uf)" type="checkbox" name="uf.selecionado" value="{{uf.selecionado}}"
                  [disabled]="todosEstados" />
                <span> {{ uf.nome }}</span>
              </li>
            </ul>
          </div>

          <p>Município:</p>
          <div class="uf-div">
            <ul>
              <input (change)="setAllMunicipio()" type="checkbox" *ngIf="municipios.length > 1" />
              <span *ngIf="municipios.length > 1">Todos </span>
              <li *ngFor="let city of municipios" style="padding: 2px !important;">
                <input (change)="getSelectedMunicipio(city)" type="checkbox" name="citys" value="{{city.nome}}"
                  [disabled]="todosMunicipios" />
                <span> {{ city.nome }}</span>
              </li>
            </ul>
          </div>

          <p>Tipo:</p>
          <div class="tipo-div">
            <ul>
              <li *ngFor="let tipo of tiposInstituicoes" style="padding: 2px !important;">
                <input (change)="getSelectedTipoInstituicao(tipo)" type="checkbox" name="tipos" value="{{tipo.nome}}" />
                <span> {{ tipo.nome }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <input hidden name="estadosSelecionados" />
      <input hidden name="municipiosSelecionados" />
      <input hidden name="tipoInstituicaoSelecionados" />
      <button type="submit" class="btn btn-md btn-dark rounded-pill cursor-pointer">
        Aplicar filtro
      </button>
    </div>
  </form>
</div>